import { CouponLineScanEventAttachmentContainerModel } from "../../../../../../models/aggregates/erp";
import {
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  Pagination,
  PagingResponseModel,
  BasicApiResponseModel
} from "../../shared";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class CouponLineScanEventAttachmentsService extends BaseApiTemplateService<CouponLineScanEventAttachmentContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "coupon-line-scan-event-attachments";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "coupon-line-scan-event-attachments";
    this.httpClient = http;
  }

  getCouponLineScanEventByGuid(guid: string, visa: ApiVisa): Observable<BasicApiResponseModel<CouponLineScanEventAttachmentContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<CouponLineScanEventAttachmentContainerModel>>(
      this.apiUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

  replaceFileWithDetails(formData: FormData, imageGuid, visa: ApiVisa) {
    let url = this.apiUrl + '/file/' + imageGuid + '/upload';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + imageGuid + '/upload';
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  // getCouponLineScanEventByCriteria(pagination: Pagination, visa: ApiVisa):
  // Observable<PagingResponseModel<CouponLineScanEventContainerModel>> {
  //   let url = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
  //   if (visa.api_domain_url) {
  //     url = visa.api_domain_url + this.endpoint_path + '/query?' + pagination.getQueryKeyValues();
  //   }
  //   return this.httpClient.get<PagingResponseModel<CouponLineScanEventContainerModel>>
  //   (url, this.getHttpHeader(visa));
  // }
}
